import HackTimer from 'hacktimer'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import {LicenseManager} from "ag-grid-enterprise";
//LicenseManager.setLicenseKey("CompanyName=Telsasoft,LicensedApplication=Telsasoft WebApp,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-014849,ExpiryDate=9_April_2022_[v2]_MTY0OTQ1ODgwMDAwMA==70f38dff73f2c09afe3ac0f749446591");
//LicenseManager.setLicenseKey("CompanyName=Telsasoft,LicensedApplication=Telsasoft WebApp,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-025712,ExpiryDate=9_April_2023_[v2]_MTY4MDk5NDgwMDAwMA==21cd362670b614af064d72759861f54d");
//LicenseManager.setLicenseKey("CompanyName=Telsasoft,LicensedApplication=Telsasoft WebApp,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-038078,SupportServicesEnd=8_April_2024_[v2]_MTcxMjUzMDgwMDAwMA==d1f25d41ad24434f80c480ce1ba32186");
//LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-054664}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Telsasoft}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Telsasoft_WebApp}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Telsasoft_WebApp}_need_to_be_licensed___{Telsasoft_WebApp}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{8_April_2025}____[v3]_[01]_MTc0NDA2NjgwMDAwMA==e29801c787df770cd05abe7ecb7854c6");
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-076345}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Telsasoft}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Telsasoft_WebApp}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Telsasoft_WebApp}_need_to_be_licensed___{Telsasoft_WebApp}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{8_April_2026}____[v3]_[01]_MTc3NTYwMjgwMDAwMA==bc7c29bf32d38a046de34ca0c9539254");

//import './registerServiceWorker'
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;

import vuetify from '@/plugins/vuetify';
//import * as VueGoogleMaps from 'vue2-google-maps'

//import CKEditor from '@ckeditor/ckeditor5-vue';
//Vue.use( CKEditor );

// Vue.use(VueGoogleMaps, {
//     load: {
//         key: 'AIzaSyCT5eLcVMKyPSicy_5iEn8onYno7aHnAgQ',

//         libraries: 'places,visualization,geometry', // This is required if you use the Autocomplete plugin
//         // libraries: 'places,visualization,geometry,marker', // This is required if you use the Autocomplete plugin
//         //v: 'beta'

//         // OR: libraries: 'places,drawing'
//         // OR: libraries: 'places,drawing,visualization'
//         // (as you require)

//         //// If you want to set the version, you can do so:
//         // v: '3.26',
//         //mapId: '1eb73715207bcf22'
//     },
   
//     //// If you intend to programmatically custom event listener code
//     //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
//     //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
//     //// you might need to turn this on.
//     // autobindAllEvents: false,

//     //// If you want to manually install components, e.g.
//     //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
//     //// Vue.component('GmapMarker', GmapMarker)
//     //// then disable the following:
//     installComponents: true,
// });

Vue.config.productionTip = false

try {document.getElementById('installing-app').remove();} catch (error) {console.log(error);}

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')

